import { get, } from "@/api/axios";

// 获取优惠劵列表
export const list = params => get('/web/coupon/use/list', params);



